import { render, staticRenderFns } from "./RecruitingServicesBase.vue?vue&type=template&id=52ddf373&scoped=true"
import script from "./RecruitingServicesBase.vue?vue&type=script&lang=js"
export * from "./RecruitingServicesBase.vue?vue&type=script&lang=js"
import style0 from "./RecruitingServicesBase.vue?vue&type=style&index=0&id=52ddf373&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ddf373",
  null
  
)

export default component.exports